(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("lodash.throttle"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "lodash.throttle"], factory);
	else if(typeof exports === 'object')
		exports["ReactOnScreen"] = factory(require("react"), require("prop-types"), require("lodash.throttle"));
	else
		root["ReactOnScreen"] = factory(root["react"], root["prop-types"], root["lodash.throttle"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition